/**
 * Returns a new object with the key/value pairs from `obj` that are not in the array `omitKeys`.
 */
export function omit(obj, omitKeys) {
    var result = {};
    Object.keys(obj).forEach(function (key) {
        if (omitKeys.indexOf(key) === -1) {
            result[key] = obj[key];
        }
    });
    return result;
}
//# sourceMappingURL=utils.js.map


// WEBPACK FOOTER //
// ../../src/components/utils.ts